import { BaseModel } from "./BaseModel";

export class Subnet extends BaseModel {
  schema = "/subnet";
  constructor(params) {
    return super(params, "/subnet");
  }
}
